module.exports = __webpack_public_path__ + "media/categories/1081-44d4fa5a.svg";